export default __webpack_public_path__ + "static/covered-car-b14b42c268006779d48fb05dedb94d8e.png";